import { useConfigStore } from "../../Stores/Config";
import { useRouterStore } from "../../Stores/Router";
import { resolveHomeVersion } from "./homeVersions";

// Renders the home screen for the configured version. All version selection
// lives here + in homeVersions.ts — no scattered `config.v === N` checks.
const Home = () => {
  const configStore = useConfigStore();
  // Remount on every closed→open transition (see widgetOpenCount) so the
  // home's entrance choreography replays at the moment the widget is actually
  // revealed — not at cold-boot mount time, which happens invisibly behind
  // the SDK's loading placeholder.
  const openCount = useRouterStore((state) => state.widgetOpenCount);
  const HomeVersion = resolveHomeVersion(configStore.getHomeVersion());
  return <HomeVersion key={openCount} />;
};

export default Home;
